import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        accordionRowFeature: {
          module: () => import('./accordion-row.module').then((m) => m.AccordionRowModule)
        },
      }
    })
  ]
})
export class AccordionRowFeatureModule {}
